const _ = require("lodash");
const {
	findArguments,
	findOptionalArgument,
	makeMathCommandNode,
	makeNonmathCommandNode,
} = require("../util/ParserHelpers");
const {scaleFont} = require("../util/RenderHelpers");

const makeParser = (sizeType, mathMode) => {
	const makeCommandNode = mathMode
		? makeMathCommandNode
		: makeNonmathCommandNode;
	return function(ps) {
		const optArg1 = findOptionalArgument(ps);
		let fontSizeMultiplier;
		if (optArg1) {
			fontSizeMultiplier = parseFloat(optArg1.text);
			if (_.isNaN(fontSizeMultiplier) || fontSizeMultiplier <= 1) {
				fontSizeMultiplier = 1;
			}
		}
		return makeCommandNode(sizeType, findArguments(ps, 1), {
			fontSizeMultiplier,
		});
	};
};

const makeNode = sizeType => {
	return {
		draw(rc, x, y, node, measure) {
			return rc.drawNode(rc, x, y, node.children[0]);
		},
		measure(rc, fontInfo, props, node) {
			let fontScaling = sizeType === "bigger" ? 1.25 : 0.8;
			if (node.fontSizeMultiplier) {
				fontScaling =
					sizeType === "bigger"
						? node.fontSizeMultiplier
						: 1 / node.fontSizeMultiplier;
			}
			const newFontInfo = scaleFont(fontInfo, fontScaling);
			return rc.measureNode(rc, newFontInfo, props, node.children[0]);
		},
		readAloud: {children: true},
	};
};

module.exports = {
	parsers: {
		nonmathCommands: {
			bigger: makeParser("bigger", false),
			smaller: makeParser("smaller", false),
		},
		mathCommands: {
			bigger: makeParser("bigger", true),
			smaller: makeParser("smaller", true),
		},
	},
	nodes: {
		bigger: makeNode("bigger"),
		smaller: makeNode("smaller"),
	},
};
